import React from "react";
import type { EquipmentCategoryType } from "../../../utils/types";
import { useEquipmentV2Selector } from "../../../redux/store";
import * as ContentStyles from "../styles/EquipmentContent";
import EquipmentDescription from "./EquipmentDescription";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import CashPrice from "./CashPrice";
import MonthlyPrice from "./MonthlyPrice";
import { getModelMapValueById } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { showEquipmentPrice } from "../../../utils/utils";
import {
    getAemMonthlyRateFormat,
    getAemPriceConfig,
} from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";

type ItemListType = {
    items?: EquipmentCategoryType["items"];
    categoryId: string; // necessary for tracking
    categoryName: string; // necessary for tracking
};

const ItemList = (props: ItemListType): JSX.Element => {
    const { items, categoryId, categoryName } = props;
    const settings = useEquipmentV2Selector((state) => state.commonSettings);
    const modelCode = useEquipmentV2Selector(
        (state) => getModelMapValueById(state.commonSettings, state.equipment.selectedCar.modelId, false)?.internalCode,
    );
    const financeInfo = useEquipmentV2Selector((state) => state.finance.info);

    return (
        <div>
            {items &&
                items.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <ContentStyles.ListItem key={`${item.name}-${index}`}>
                        <div>
                            <Type.Strong role="heading" aria-level={3}>
                                {item.name}
                            </Type.Strong>
                            {item.description && (
                                <div>
                                    <EquipmentDescription
                                        description={item.description}
                                        categoryId={categoryId}
                                        categoryName={categoryName}
                                        equipmentId={item.id}
                                        equipmentName={item.name}
                                    />
                                </div>
                            )}
                        </div>
                        {showEquipmentPrice(item.price) && (
                            <div>
                                <CashPrice
                                    price={item.price}
                                    priceConfig={getAemPriceConfig(
                                        settings,
                                        AemFmComponent.OptionalEquipment,
                                        modelCode,
                                    )}
                                    cultureName={settings.culture.name}
                                />
                                <MonthlyPrice
                                    price={item.price}
                                    financeItemId={item.id}
                                    priceFormat={getAemMonthlyRateFormat(
                                        settings,
                                        AemFmComponent.OptionalEquipment,
                                        "new",
                                        modelCode,
                                    )}
                                    financeInfo={financeInfo}
                                />
                            </div>
                        )}
                    </ContentStyles.ListItem>
                ))}
        </div>
    );
};

export default ItemList;
